import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface ApiFilter {
  field?: string;
  op?: ":" | "=";
  value: string;
  joinOp?: "AND" | "OR";
  not?: boolean;
}

export interface SearchLogsPayload {
  timeRange?: { from: string; to: string };
  filters?: ApiFilter[];
  page?: { size?: number; cursor?: unknown[] | null };
}

export interface LogsHistogramBucket {
  bucket: string;
  total: number;
  ERROR?: number;
  WARN?: number;
  INFO?: number;
  DEBUG?: number;
  TRACE?: number;
}

export interface ApiLog {
  id: string;
  timestamp: string;
  level: string;
  reflectorId: string;
  reflectorName: string;
  reflectorUuid: string;
  source: string;
  message: string;
}

export interface SearchLogsResponse {
  total: number;
  logs: ApiLog[];
  nextCursor: unknown[] | null;
  histogram: LogsHistogramBucket[] | null;
  timeRange: { from: string; to: string };
}

/**
 * POST /api/v2/reflector/logs/search
 * Returns logs + per-level histogram for the caller's tenant.
 */
export function searchLogs(
  tenantId: number,
  token: string,
  payload: SearchLogsPayload
) {
  const params = new URLSearchParams({ tenantId: tenantId.toString() });
  return axios.post<SearchLogsResponse>(
    `${API_URL}/v2/reflector/logs/search?${params.toString()}`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
